(function () {
  "use strict";

  var initializedGalleries = new WeakSet();

  function excludedIndexesFor(gallery) {
    return new Set(
      (gallery.getAttribute("data-qk-excluded-media-positions") || "")
        .split(",")
        .map(function (position) {
          return Number.parseInt(position, 10) - 1;
        })
        .filter(function (index) {
          return Number.isInteger(index) && index >= 0;
        })
    );
  }

  function initializeGallery(gallery) {
    if (initializedGalleries.has(gallery)) {
      return;
    }

    var form = document.forms[gallery.getAttribute("form")];
    var excludedIndexes = excludedIndexesFor(gallery);
    var carousels = Array.from(gallery.querySelectorAll("media-carousel"));
    var pageDots = Array.from(gallery.querySelectorAll("page-dots"));
    var lastVisibleIndex = new WeakMap();

    if (!form || excludedIndexes.size === 0 || carousels.length === 0) {
      return;
    }

    initializedGalleries.add(gallery);

    carousels.forEach(function (carousel) {
      var initialIndex = excludedIndexes.has(carousel.selectedIndex)
        ? carousel.items.findIndex(function (_item, index) {
            return !excludedIndexes.has(index);
          })
        : carousel.selectedIndex;

      lastVisibleIndex.set(carousel, Math.max(0, initialIndex));
    });

    gallery.addEventListener("carousel:change", function (event) {
      if (excludedIndexes.has(event.detail.index)) {
        return;
      }

      carousels.forEach(function (carousel) {
        if (carousel.contains(event.detail.slide)) {
          lastVisibleIndex.set(carousel, event.detail.index);
        }
      });
    });

    function enforceExclusions() {
      carousels.forEach(function (carousel) {
        var items = Array.from(carousel.items);
        var filteredIndexes = [];

        items.forEach(function (item, index) {
          if (item.hidden || excludedIndexes.has(index)) {
            filteredIndexes.push(index);
          }
        });

        carousel.dispatchEvent(
          new CustomEvent("carousel:filter", {
            detail: { filteredIndexes: filteredIndexes },
          })
        );

        pageDots.forEach(function (dots) {
          dots.dispatchEvent(
            new CustomEvent("control:filter", {
              detail: { filteredIndexes: filteredIndexes },
            })
          );
        });

        if (!filteredIndexes.includes(carousel.selectedIndex)) {
          lastVisibleIndex.set(carousel, carousel.selectedIndex);
          return;
        }

        var fallbackIndex = lastVisibleIndex.get(carousel);

        if (filteredIndexes.includes(fallbackIndex)) {
          fallbackIndex = items.findIndex(function (_item, index) {
            return !filteredIndexes.includes(index);
          });
        }

        if (fallbackIndex >= 0) {
          carousel.select(fallbackIndex, { animate: false });
        }
      });
    }

    form.addEventListener("variant:change", function () {
      queueMicrotask(enforceExclusions);
    });

    enforceExclusions();
  }

  function initializeAll() {
    document
      .querySelectorAll("product-gallery[data-qk-excluded-media-positions]")
      .forEach(initializeGallery);
  }

  customElements.whenDefined("product-gallery").then(initializeAll);
  document.addEventListener("shopify:section:load", initializeAll);
})();
